import Space from './Space';

export { Space };
export default Space;
export type { SpaceProps } from './type';
